import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const D = {
  es: {
    home: "INICIO", about: "NOSOTROS", services: "SERVICIOS", solutions: "SOLUCIONES", clients: "CLIENTES", resources: "RECURSOS", contact: "CONTACTO",
    demo: "Solicitar demostración", portal: "Clientes", cart: "Carrito", explore: "Explorar soluciones",
    heroTitle: "Tecnología que impulsa tu negocio.",
    heroSub: "Desarrollamos soluciones de software, plataformas empresariales y tecnologías innovadoras que transforman la manera en que las organizaciones operan y crecen.",
    trustTitle: "Empresas que han confiado en nuestra tecnología", testiTitle: "Lo que nuestros clientes dicen de nosotros",
    techTitle: "Tecnologías con las que construimos soluciones", more: "Ver más", requestInfo: "Solicitar información",
    addCart: "Agregar al carrito", checkout: "Finalizar compra", login: "Iniciar sesión",
  },
  en: {
    home: "HOME", about: "ABOUT", services: "SERVICES", solutions: "SOLUTIONS", clients: "CLIENTS", resources: "RESOURCES", contact: "CONTACT",
    demo: "Request a demo", portal: "Clients", cart: "Cart", explore: "Explore solutions",
    heroTitle: "Technology that drives your business.",
    heroSub: "We build software solutions, enterprise platforms and innovative technologies that transform the way organizations operate and grow.",
    trustTitle: "Companies that have trusted our technology", testiTitle: "What our clients say about us",
    techTitle: "Technologies we build solutions with", more: "See more", requestInfo: "Request information",
    addCart: "Add to cart", checkout: "Checkout", login: "Sign in",
  },
};

const I18n = createContext(null);
const SiteCtx = createContext({});

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("cc_lang") || "es");
  useEffect(() => {
    localStorage.setItem("cc_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = useCallback((k) => D[lang][k] || D.es[k] || k, [lang]);
  return <I18n.Provider value={{ lang, setLang, t }}>{children}</I18n.Provider>;
}

export function SiteProvider({ children }) {
  const [site, setSite] = useState({});
  const load = useCallback(() => api.get("/public/settings").then((r) => setSite(r.data)).catch(() => {}), []);
  useEffect(() => {
    load();
  }, [load]);
  useEffect(() => {
    const p = site.palette || {};
    const root = document.documentElement.style;
    if (p.navy) root.setProperty("--cc-navy", p.navy);
    if (p.blue) root.setProperty("--cc-blue", p.blue);
    if (p.accent) root.setProperty("--cc-accent", p.accent);
    if (p.charcoal) root.setProperty("--cc-charcoal", p.charcoal);
  }, [site]);
  return <SiteCtx.Provider value={{ site, reloadSite: load }}>{children}</SiteCtx.Provider>;
}

export const useT = () => useContext(I18n);
export const useSite = () => useContext(SiteCtx);
